export const buildNumber = '20260623.3';
export const version = '3.14.1';
export const latestCommit = 'e3e29dd43e353d69a59d04928214112c94d2ca30';
